import * as React from 'react';
import {CSSProperties} from 'react';
import {CheckboxChangeEvent} from 'antd/lib/checkbox';
import {Button, Checkbox, Form, Icon, Input} from 'antd';
import {Todo, TodoEntry} from '../api/dtos/dtos';
import * as formUtils from '../utils/form-utils';
import locales from '../locales';
import FormItem from 'antd/lib/form/FormItem';
import ButtonBar from '../common/ButtonBar';

import './SummaryTodoForm.css';


interface Props {
  todo: Todo | null;
  editable: boolean;
  onFormCancel: () => void;
  onFormSubmit: (todo: Todo) => void;
}

interface State {
  entries: TodoEntry[];
}

const emptyEntry = (): TodoEntry => ({
  checked: false,
  text: '',
});


class SummaryTodoForm extends React.Component<Props, State> {

  public state: State = {
    entries: this.props.todo ? this.props.todo.entries : [emptyEntry()],
  };

  private cbStyle: CSSProperties = {
    lineHeight: '21px',
  };

  private inputStyle: CSSProperties = {
    marginBottom: 16,
  };

  public render(): React.ReactNode {
    const {entries} = this.state;
    const {editable} = this.props;
    return (
      <Form>
        {editable && (
          <ButtonBar style={{marginBottom: 8}}>
            <Button size="small" type="primary" icon="plus" onClick={this.onAddButtonClick}>
              {locales.add}
            </Button>
          </ButtonBar>
        )}

        <div className="todo-form">
          {entries.map(this.renderRow)}
        </div>

        {this.props.children}

        <FormItem {...formUtils.tailFormItemLayout}>
          {editable && (
            <Button type="primary" onClick={this.onFormSubmit}>
              {locales.save}
            </Button>
          )}
          <Button style={{marginLeft: 8}} onClick={this.props.onFormCancel}>
            {locales.cancel}
          </Button>
        </FormItem>
      </Form>
    );
  }

  private renderRow = (entry: TodoEntry, idx: number): React.ReactNode => {
    const {editable} = this.props;

    const addonBefore: React.ReactNode = (
      <div style={this.cbStyle}>
        <Checkbox checked={entry.checked} onChange={this.onCheckBoxChange(idx)} disabled={!editable}/>
      </div>
    );

    const addonAfter: React.ReactNode = editable && (
      <a onClick={this.onDeleteClick(idx)} title={locales.delete}>
        <Icon type="delete"/>
      </a>
    );

    const inputClassName = entry.checked ? 'checked' : undefined;

    return (
      <Input
        key={`row-${idx}`}
        disabled={!editable}
        className={inputClassName}
        style={this.inputStyle}
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        placeholder={locales.reminder}
        value={entry.text}
        onChange={this.onInputChange(idx)}
      />
    );
  };

  private onInputChange = (idx: number) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.replaceEntryAt(idx, {
      checked: this.state.entries[idx].checked,
      text: evt.target.value,
    });
  };

  private replaceEntryAt(idx: number, entry: TodoEntry) {
    const entries = [...this.state.entries];
    entries.splice(idx, 1, entry);
    this.setState({entries,});
  }

  private onCheckBoxChange = (idx: number) => (evt: CheckboxChangeEvent) => {
    this.replaceEntryAt(idx, {
      checked: evt.target.checked,
      text: this.state.entries[idx].text,
    });
  };

  private onDeleteClick = (idx: number) => () => {
    const entries = [...this.state.entries];
    entries.splice(idx, 1);

    if (entries.length === 0) {
      entries.push(emptyEntry());
    }

    this.setState({entries,});
  };

  private onFormSubmit = () => {
    this.props.onFormSubmit({
      entries: this.state.entries,
    });
  };

  private onAddButtonClick = () => {
    const {entries} = this.state;
    this.setState({
      entries: [emptyEntry(), ...entries],
    });
  };

}

export default SummaryTodoForm;


// WEBPACK FOOTER //
// ./src/summary/SummaryTodoForm.tsx